module.exports = __webpack_public_path__ + "static/media/YF20_0.49000af8.jpg";